import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  posOrdersControllerCancel,
  posOrdersControllerCreate,
  posOrdersControllerGetById,
  posOrdersControllerGetBySession,
} from '@klubovna/api-client';
import { CreateOrderDto, PosOrder } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PosOrdersApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);
  private rootUrl = this.apiConfig.rootUrl;

  createOrder(body: CreateOrderDto): Observable<PosOrder> {
    return posOrdersControllerCreate(this.http, this.rootUrl, { body }).pipe(
      map((response) => response.body!),
    );
  }

  getById(id: string): Observable<PosOrder> {
    return posOrdersControllerGetById(this.http, this.rootUrl, { id }).pipe(
      map((response) => response.body!),
    );
  }

  cancelOrder(id: string): Observable<PosOrder> {
    return posOrdersControllerCancel(this.http, this.rootUrl, { id }).pipe(
      map((response) => response.body!),
    );
  }

  getBySession(sessionId: string, limit?: number, page?: number): Observable<PaginatedResponse<PosOrder>> {
    return posOrdersControllerGetBySession(this.http, this.rootUrl, { sessionId, limit, page }).pipe(
      map((response) => toPaginatedResponse<PosOrder>(response.body)),
    );
  }
}
